







































































import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class WQtypeRadioView extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;
	@Prop()
	injectedAnswer!: any;
	@Prop()
	injectedStats!: any;
	@Prop({ type: Boolean, default: false })
	lock!: boolean;

	answerValue = (this.injectedAnswer || { value: "" }).value;
	othersValue = (this.injectedAnswer || { othersValue: "" }).othersValue;

	get showOthersField() {
		return this.answerValue === this.options.othersChoiceUuid;
	}

	get form() {
		return {
			fields: {
				answer: {
					field: "radio"
				}
			}
		};
	}

	stats(uuid: string) {
		if (this.injectedStats) {
			let choiceStats = this.injectedStats.choices[uuid],
				total = this.injectedStats.questionAnswersCount,
				count = choiceStats.count,
				percent =
					parseInt(String((count / (total || 1)) * 10000)) / 100;

			return {
				total,
				count,
				percent
			};
		}
		return {};
	}

	@Watch("answerValue")
	watchAnswerValue() {
		this.onAnswerChange();
	}

	@Watch("othersValue")
	watchOthersValue() {
		this.onAnswerChange();
	}

	@Emit("type-answer-change")
	onAnswerChange() {
		let others = this.showOthersField;

		return {
			othersValue: others ? this.othersValue : "",
			value: this.answerValue,
			isValid: others ? !!this.othersValue.length : !!this.answerValue,
			isEmpty: !this.answerValue
		};
	}

	mounted() {
		this.onAnswerChange();
	}
}
